import { Show, Tab  } from "src/enterprise/ra-rbac";
import * as React from "react";
import {
  DateField,
  FunctionField,
  TabbedShowLayout,
  useRecordContext
} from "react-admin";
import { Typography, Grid, Chip, Card } from "@mui/material";
import { ShippingAndHandlingCard, AddressCard, CFACard } from "src/resources/sales/cards";
import { useState } from "react";
import { ItemsTable, TotalsTable, HistoryTable, TransactionTable, ShipmentTable } from "./tables";
import { OrderShowComponent } from './OrderComponent';
import { PackingList } from "src/resources/sales/cards";

const OrderShowForm = () => {
  const record = useRecordContext();
  if (!record) { return null; }
 
  return (
    <TabbedShowLayout>
      <Tab label="Information" name="information">
        <Grid container spacing={4}>
          <Grid item sm={12} md={12}>
            <Typography variant="h6" gutterBottom>General Information</Typography>
            <Card
              sx={{
                padding: "10px",
                border: "1px solid #ebebeb",
                borderRadius: "8px"
              }}
            >
              <Typography variant="subtitle2" gutterBottom>Order Date: <DateField showTime={true} source="created_at" /></Typography>
              <Typography variant="subtitle2" gutterBottom sx={{ display: "flex", alignItems: "center"}}>Placed By: <FunctionField
                  sx={{ marginLeft: "4px"}}
                  render={(record) =>
                    record.user
                      ? `${record.user.first_name} ${record.user.last_name}, ${record.user.email}`
                      : "Guest User"
                  }
                />
                {record?.user?.role &&
                <Chip
                  sx={{height: "22px", marginLeft: "10px", paddingBottom: "2px"}}
                  label={record?.user?.role?.name}
                />
                }
              </Typography>
              { record.note &&
              <Typography variant="subtitle2" gutterBottom>Additional Note: <Typography variant="body2" component="span">{record.note}</Typography></Typography>
              }
            </Card>
          </Grid>

          { !['pending', 'pending_payment', 'backorder', 'reserve', 'na_reserve', 'request'].includes(record.status) &&
          <Grid item sm={12} md={4}>
            <Typography variant="h6" gutterBottom>Packing List</Typography>
            <PackingList
              record={record}
            />
          </Grid>
          }

          <Grid item sm={12} md={4}>
            <Typography variant="h6" gutterBottom>Billing Address</Typography>
            <AddressCard
              record={record}
              type="billing"
            />
          </Grid>

          <Grid item sm={12} md={4}>
            <Typography variant="h6" gutterBottom>Shipping Address</Typography>
            <AddressCard
              record={record}
              type="shipping"
            />
          </Grid>

          { record.shipping_method &&
          <Grid item sm={12} md={4}>
            <Typography variant="h6" gutterBottom>Shipping & Handling Information</Typography>
            <ShippingAndHandlingCard
              record={record}
            />
          </Grid>
          }

          { record.cfa &&
          <Grid item sm={12} md={4}>
            <Typography variant="h6" gutterBottom>CFA Information</Typography>
            <CFACard
              record={record}
            />
          </Grid>
          }

          <Grid container item sm={12} md={12}>
            <Typography variant="h6" gutterBottom>Items</Typography>
            <ItemsTable record={record} currency={record.currency} />
          </Grid>
          <Grid container item sm={12} md={12} direction="row-reverse">
            <Grid item sm={12} md={6}>
              <Typography variant="h6" gutterBottom>Totals</Typography>
              <TotalsTable record={record} currency={record.currency} />
            </Grid>
          </Grid>
        </Grid>
      </Tab>
      <Tab label="Order History" name="order_history">
        <HistoryTable record={record}/>
      </Tab>
      <Tab label="Transactions" name="transactions">
        <TransactionTable record={record}/>
      </Tab>
      <Tab label="Shipment" name="shipment">
        <ShipmentTable record={record}/>
      </Tab>
    </TabbedShowLayout>
  );
};


export const OrderShow = () => {
  return (
    <Show component={OrderShowComponent} actions={null}>
      <OrderShowForm />
    </Show>
  );
};
